import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import General from './general/component';
import Company from './companies/component';
import Structure from './structure/component';
import ViewSingleTemplateTasks from 'components/views/admin/templates/single/tasks/listing/component';
import { SIDEBAR_MODE_ADMIN } from 'components/constants';
import { adminGetTemplateAction, adminResetTemplateStateAction } from '../../../../../redux/actions/admin/admin.actions';
export default function ViewSingleTemplate() {
    var dispatch = useDispatch();
    var id = useParams().id;
    var template = useSelector(function (state) { return state.admin.singleTemplate; });
    var authToken = useSelector(function (state) { return state.userAuthorization.token; });
    var _a = useState(1), activeTab = _a[0], setActiveTab = _a[1];
    useEffect(function () {
        dispatch(adminResetTemplateStateAction());
        dispatch(adminGetTemplateAction(id, authToken));
    }, [authToken, id]);
    function getActiveTab() {
        if (!template)
            return null;
        switch (activeTab) {
            case 1: return React.createElement(General, null);
            case 2: return React.createElement(Structure, null);
            case 3: return React.createElement(Company, null);
            case 4: return React.createElement(ViewSingleTemplateTasks, null);
            default: return null;
        }
    }
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_ADMIN }),
        React.createElement("div", { className: "mar-left-80 mar-top-80" },
            React.createElement("div", { style: { maxWidth: '75em', margin: 'auto', padding: '0 1em' } },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '2em' } },
                    React.createElement("div", { style: { display: 'flex', gap: '.5em', flexDirection: 'row', alignItems: 'center' } },
                        React.createElement("button", { onClick: function () { return setActiveTab(1); } }, "Edit Template"),
                        React.createElement("button", { onClick: function () { return setActiveTab(2); } }, "Structure"),
                        React.createElement("button", { onClick: function () { return setActiveTab(3); } }, "Companies"),
                        React.createElement("button", { onClick: function () { return setActiveTab(4); } }, "Tasks")),
                    getActiveTab())))));
}
